export default __webpack_public_path__ + "img/empty-notify.053a9ddd.svg";